import React from 'react';
import { ModalInstanceProps } from '../interfaces';
import { OpenPrettyErrorModalParams } from '@mm/state/modules/modalsState/actions';
import { Button, Link } from '@mm/components';
import classNames from 'classnames';
import styles from './PrettyErrorModal.module.css';
import { CloseOutlined } from '@ant-design/icons';
import dangerImg from 'assets/danger-triangle.png';

type Props = ModalInstanceProps & OpenPrettyErrorModalParams;

export const PrettyErrorModal = (props: Props) => {
  const {
    title,
    errorMessage,
    closeModal,
    detailsForNerds,
    onClose,
    css,
    image = dangerImg,
    contactSupport,
    buttonText = 'Dismiss',
  } = props;

  const onModalClose = () => {
    closeModal();
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className={classNames(styles.container, css?.container)}>
      <CloseOutlined className={styles.closeIcon} onClick={onModalClose} />
      {image && <img src={image} className={css?.image} />}

      <div className={classNames(styles.title, css?.title)}>{title}</div>

      <div
        className={classNames(
          styles.description,
          css?.description,
          styles.text,
        )}
      >
        <div>
          {errorMessage}
          {contactSupport && (
            <div>
              If this error persists, please contact{' '}
              <Link
                isBlank
                href="mailto:support@customers.ai"
                capitalize={false}
              >
                support@customers.ai
              </Link>{' '}
              .
            </div>
          )}
        </div>

        {detailsForNerds && (
          <div className={styles.details}>
            <div className={styles.text} style={{ fontWeight: 500 }}>
              Details for nerds:
            </div>
            <div className={classNames(styles.text, styles.textForNerds)}>
              {detailsForNerds}
            </div>
          </div>
        )}
      </div>

      <Button
        onClick={onModalClose}
        css={{ container: classNames(styles.button, css?.button) }}
      >
        {buttonText}
      </Button>
    </div>
  );
};
